export default __webpack_public_path__ + "static/media/acct-invoice-lines.c7d9f094.png";